import { render, staticRenderFns } from "./AddressesListPopup.vue?vue&type=template&id=55b30c1f&scoped=true&"
import script from "./AddressesListPopup.vue?vue&type=script&lang=js&"
export * from "./AddressesListPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddressesListPopup.vue?vue&type=style&index=0&id=55b30c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b30c1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b30c1f')) {
      api.createRecord('55b30c1f', component.options)
    } else {
      api.reload('55b30c1f', component.options)
    }
    module.hot.accept("./AddressesListPopup.vue?vue&type=template&id=55b30c1f&scoped=true&", function () {
      api.rerender('55b30c1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/AddressesListPopup.vue"
export default component.exports